module.exports = __webpack_public_path__ + "static/media/underCon.cbc42596.svg";